import { defineMessage } from 'react-intl'
import { queryKeyFilters } from 'constants/url'
import { isEmpty } from 'lib/array/arrayUtils'
import { getCurrentIntl } from 'i18n/util/currentIntl'
export default function isAnyFilterApplied(params: Record<string, any> = {}): boolean {
  return !isEmpty(params) && queryKeyFilters.some(filterKey => !isEmpty(params[filterKey]))
}

const PAYMENT_OPTION_LABELS = {
  pay_at_property: defineMessage({
    id: 'wsraWhd3Ov41Vw9oaHyP',
    defaultMessage: 'Pay at property',
  }),
}

export function mapPaymentOptionLabel(item: App.FilterItem): App.FilterItem {
  const message = PAYMENT_OPTION_LABELS[item.slug as keyof typeof PAYMENT_OPTION_LABELS]
  return message ? { ...item, label: getCurrentIntl().formatMessage(message) } : item
}
